import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const ALL = "__all__";
const CONTENT_CLASS = "z-[130] max-h-72 rounded-xl border-[#EFEBE0] bg-white shadow-[0_12px_40px_-8px_rgba(62,39,35,0.3)]";
const ITEM_CLASS = "rounded-lg text-sm text-[#5D4037] focus:bg-[#F5F2EB] focus:text-[#3E2723]";

export function CocoaSelect({ value, onChange, options, placeholder = "All", testId, className = "" }) {
  return (
    <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? "" : v)}>
      <SelectTrigger data-testid={testId}
        className={`h-10 rounded-lg border-[#E5DFD3] bg-white px-3 text-sm text-[#3E2723] shadow-none focus:ring-2 focus:ring-[#8D6E63] focus:ring-offset-0 data-[placeholder]:text-[#84675B] ${className}`}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent position="popper" sideOffset={4} className={CONTENT_CLASS}>
        <SelectItem value={ALL} className={ITEM_CLASS}>{placeholder}</SelectItem>
        {options.map((o) => {
          const [v, l] = Array.isArray(o) ? o : [o, o];
          return <SelectItem key={v} value={v} className={ITEM_CLASS}>{l}</SelectItem>;
        })}
      </SelectContent>
    </Select>
  );
}

function optionText(children) {
  if (typeof children === "string" || typeof children === "number") return String(children);
  if (Array.isArray(children)) return children.map((c) => optionText(c)).join("");
  return "";
}

function optionsFromChildren(children, out = []) {
  React.Children.forEach(children, (child) => {
    if (!child || typeof child !== "object") return;
    if (child.type === "option") {
      out.push({ value: String(child.props.value ?? optionText(child.props.children)), label: child.props.children, disabled: !!child.props.disabled });
    } else if (child.props?.children) {
      optionsFromChildren(child.props.children, out);
    }
  });
  return out;
}

export function NativeLikeSelect({ children, value, onChange, disabled, placeholder, placeholderDisabled = false, triggerClass = "", id, "data-testid": testId, ...rest }) {
  const opts = optionsFromChildren(children);
  const hasEmpty = opts.some((o) => o.value === "");
  const items = placeholder !== undefined && !hasEmpty ? [{ value: "", label: placeholder, disabled: placeholderDisabled }, ...opts] : opts;
  const val = value == null ? "" : String(value);
  const emptyItem = items.find((o) => o.value === "");
  return (
    <Select value={val === "" ? ALL : val} disabled={disabled}
      onValueChange={(v) => onChange && onChange({ target: { value: v === ALL ? "" : v } })}>
      <SelectTrigger data-testid={testId} id={id} className={`shadow-none focus:ring-offset-0 data-[placeholder]:text-[#84675B] ${triggerClass}`}>
        <SelectValue placeholder={emptyItem ? emptyItem.label : (placeholder || "")} />
      </SelectTrigger>
      <SelectContent position="popper" sideOffset={4} className={CONTENT_CLASS}>
        {items.map((o, i) => (
          <SelectItem key={`${o.value}-${i}`} value={o.value === "" ? ALL : o.value} disabled={o.disabled} className={ITEM_CLASS}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
